const LoadingComponent = () => {
  return <div>Loading...</div>;
};

export default LoadingComponent;
